export class AbortControllerManager {
  private controllers: Map<string, AbortController> = new Map();

  createAbortController(key: string): AbortSignal {
    this.abortRequest(key);
    const controller = new AbortController();
    this.controllers.set(key, controller);
    return controller.signal;
  }

  abortRequest(key: string): void {
    if (this.controllers.has(key)) {
      this.controllers.get(key)?.abort();
      this.controllers.delete(key);
    }
  }

  abortAllRequests(): void {
    this.controllers.forEach((controller) => controller.abort());
    this.controllers.clear();
  }
}
